export default [
  {
    path: "/file/img",
    name: "fileImg",
    component: () => import("@/components/common/AxEhrImg.vue")
  }
];
